import styled from 'styled-components'
import { TabList } from 'react-tabs'

/* Common Styled Components */

export const Button = styled.button<{ isLoading?: boolean }>`
  @media (min-width: 1200px) {
    font-size: 24px;
  }

  &:disabled {
    cursor: not-allowed;

    ${(props) => props.isLoading && 'display: flex; justify-content: center; align-items: center;'}

    color: ${(props) => (props.isLoading ? 'transparent' : '#ffffff')};

    ${(props) => !props.isLoading && '-webkit-font-smoothing: antialiased;'}
    ${(props) => !props.isLoading && '-moz-osx-font-smoothing: grayscale;'}
    ${(props) => !props.isLoading && 'background-color: #afb0b3;'}
    ${(props) => !props.isLoading && 'border-color: #afb0b3;'}
    ${(props) => !props.isLoading && 'color: #ffffff;'}
   
    @media (hover: hover) {
      &:hover {
        color: ${(props) => (props.isLoading ? 'transparent' : '#ffffff')};

        ${(props) => !props.isLoading && 'background-color: #afb0b3;'}
        ${(props) => !props.isLoading && 'border-color: #afb0b3;'}
      }
    }

    &::after {
      ${(props) =>
        props.isLoading &&
        `
          content: "";
          position: absolute;
          height: 12px;
          aspect-ratio: 5;
          -webkit-mask: linear-gradient(90deg,#fff0 ,#ffffffdb 20% 80%,#fff0);
          background: radial-gradient(closest-side at 37.5% 50%,#fff 94%,#fff0) 0/calc(80%/3) 100%;
          animation: d8 .75s infinite linear;
        `}
    }
  }

  @keyframes d8 {
    100% {
      background-position: 36.36%;
    }
  }
`

export const Grid = styled.div<{
  $responsive?: boolean
  $columns?: number
}>`
  display: grid;
  grid-template-columns: ${(props) => (props.$responsive || props.$columns === 2 ? '1fr 1fr' : '1fr')};
  gap: 15px;

  @media (min-width: 1200px) {
    grid-template-columns: ${(props) => (props.$responsive ? '1fr' : '1fr 1fr')};
  }
`

export const Intro = styled.div`
  h1 {
    // desktop
    margin: 20px 0 10px;

    // mobile
    @media (max-width: 1199px) {
      margin: 5px 0 20px;
      text-transform: none;
      font-size: 24px;
      font-weight: 600;
    }
  }
`

export const Panel = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 20px;
  padding-top: 15px;

  strong {
    font-weight: 600;
  }

  .react-tabs {
    width: 100%;
  }
`

export const SubTabsList = styled(TabList)`
  display: flex;
  width: 100%;

  h1 + div > & {
    margin-top: 20px;
  }

  .react-tabs__tab {
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #e1e3e0;
    display: flex;
    flex: 1;
    justify-content: center;
  }

  .react-tabs__tab--selected {
    border-bottom: 2px solid ${(props) => props.theme.palette.primary.main};
  }

  .react-tabs__tab:focus:after {
    content: unset; // reset CSS from react-tabs
    left: -1000px; // reset CSS from react-tabs
    background-color: transparent; // reset CSS from react-tabs
  }
`
